<template>
  <div class="p-4 flex justify-between h-16">
    <button
      class="w-full flex items-center"
      @click="setOpen(false)"
    >
      <v-icon-chevron-l class="h-6 w-6 text-gray-700" />
      <span class="pl-2 text-left flex-grow text-gray-400 text-base">
        {{ trans.get('miliboo.menu.go-back') }}
      </span>
    </button>
    <button
      type="button"
      class="-m-2 p-2 rounded-md inline-flex items-center justify-center"
      @click="setOpen(false) || $emit('close')"
    >
      <span class="sr-only">{{ trans.get('miliboo.common.close') }}</span>
      <v-icon-x class="h-6 w-6 text-gray-700" />
    </button>
  </div>
</template>
<script setup>
import { inject } from 'vue';

defineProps({
  setOpen: {
    type: Function,
    required: true,
  },
});

defineEmits(['close']);

const trans = inject('translate');

</script>
